<script setup>
  import { computed } from 'vue';
  import Icon from "@/components/icons/Icon.vue";

  defineOptions({
    inheritAttrs: false
  });

  const model = defineModel();

  const emit = defineEmits(['change']);

  const props = defineProps({
    id: {
      type: String,
      required: true
    },
    labelClassList: {
      type: [String, Array],
      required: false
    }
  });

  const labelClass = computed(() => {
    let classes = 'jwx-checkbox__label';

    if (props.labelClassList) {
      if (Array.isArray(props.labelClassList)) {
        classes += ' ' + props.labelClassList.join(' ');
      } else {
        classes += ' ' + props.labelClassList;
      }
    }

    return classes;
  });

  const handleChangeEvent = (event) => {
    emit('change', event);
  };
</script>

<template>
  <input
    v-if="model"
    @change="handleChangeEvent"
    v-bind="$attrs"
    :id="props.id"
    type="checkbox"
    class="jwx-checkbox__input jwx-hidden-control"
    v-model="model"
  />
  <input
    else
    @change="handleChangeEvent"
    v-bind="$attrs"
    :id="props.id"
    type="checkbox"
    class="jwx-checkbox__input jwx-hidden-control"
  />
  <label
    :for="props.id"
    :class="labelClass"
    :data-default-style="!props.labelClassList"
  >
    <slot></slot>
    <div class="jwx-checkbox__selection-indicator">
      <Icon name="checkmark" class="jwx-checkbox__indicator-icon" />
    </div>
  </label>
</template>